<template>
    <div>
        <a-row>
            <a-col :span="1"/>
            <a-col :span="8">
                设备编号：
                <a-input style="width: calc(100% - 100px)" v-model="no"/>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="selectList">
                    查询
                </a-button>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="addDevice">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="delCar(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible"
                 title="设备信息"
                 width="40%"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="getData">
            <a-row>
                <a-col :span="3"/>
                <a-col :span="4">
                    序号：
                </a-col>
                <a-col :span="13">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    设备编号：
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.no"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    设备类型：
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.type"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    设备状态：
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.status"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    车牌号：
                </a-col>
                <a-col :span="13">
                    <my-select :select-value.sync="form.carId" :data-list="car"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    告警策略：
                </a-col>
                <a-col :span="13">
                    <my-select :select-value.sync="form.tacticsId" :data-list="deviceTactics"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    调度计划：
                </a-col>
                <a-col :span="13">
                    <my-select :select-value.sync="form.dispatchId" :data-list="dispatch"/>
                </a-col>
            </a-row>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getDeviceQueryList, getCarQueryList, deviceEditDetail, deviceDelDetail} from './js/ApiBasic';
    import {getDispatchList} from '../dispatch/js/ApiDispatch';
    import {getDeviceTacticsQueryList} from "../device/js/ApiDevice";

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderno',
            key: 'orderno',
            ellipsis: true,
        },
        {
            title: '设备编号',
            dataIndex: 'no',
            key: 'no',
            ellipsis: true,
        },
        {
            title: '设备类型',
            dataIndex: 'type',
            key: 'type',
            ellipsis: true,
        },
        {
            title: '设备状态',
            dataIndex: 'status',
            key: 'status',
            ellipsis: true,
        },
        {
            title: '纬度',
            dataIndex: 'lat',
            key: 'lat',
            ellipsis: true,
        },
        {
            title: '经度',
            dataIndex: 'lng',
            key: 'lng',
            ellipsis: true,
        },
        {
            title: '车牌号',
            dataIndex: 'car.carno',
            key: 'car.carno',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                no: '',
                visible: false,
                delVisible: false,
                car: [],
                dispatch: [],
                deviceTactics: [],
                data: {},
                lines: {},
                form: {
                    orderNo: '',
                    no: '',
                    type: '',
                    status: '',
                    carId: '',
                    tacticsId: '',
                    dispatchId:''
                },
            }
        },
        methods: {
            // 查询设备信息
            selectList() {
                this.getData({no: this.no});
            },
            // 新增按钮
            addDevice() {
                this.visible = true;
            },
            //新增-点击确定
            add() {
                this.form.orderNo = this.form.orderNo + '';
                deviceEditDetail(this.form).then(() => {
                    this.visible = false;
                    this.getData()
                }).catch(res => {
                    this.visible = false;
                    console.log(res)
                })
            },
            // 编辑按钮
            edit(row) {
                console.log(row);
                this.form = JSON.parse(JSON.stringify(row));
                this.form.orderNo = row.orderno
                this.form.tacticsId = row.tacticsid
                this.form.carId = row.carid
                this.form.dispatchId = row.dispatchid
                this.visible = true
            },
            //删除按钮
            del(row) {
                deviceDelDetail({id: row.id}).then(() => {
                    this.getData();
                });
            },
            getData(parameter) {
                if (!parameter) {
                    parameter = {}
                }
                this.resetForm();
                this.visible = false;
                getDeviceQueryList(parameter).then(res => {
                    this.data = res.data;
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    no: '',
                    type: '',
                    status: '',
                    carId: '',
                    tacticsId: '',
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getDeviceQueryList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
            // 删除按钮
            delCar(row) {
                this.lines = row;
                this.delVisible = true;
            },
            // 删除提示
            delOk() {
                this.delVisible = false;
                this.del(this.lines);
            },
            cancel() {
                this.delVisible = false;
            },
        },
        created() {
            this.getData();
            getCarQueryList({}).then(res => {
                this.car = res.data.data;
                this.car.forEach(item => {
                    item.name = item.carno
                })
            });
            getDispatchList({}).then(res => {
                this.dispatch = res.data.data
            });
            getDeviceTacticsQueryList({}).then(res => {
                this.deviceTactics = res.data.data;
            })
        }
    }
</script>

<style scoped>
    .Tips {
        font-size: 25px;
        color: #1890ff;
    }
</style>
